import type { RootState } from '@client/reduxProvider';

export const selectAdminSlice = (state: RootState): RootState['admin'] => state.admin;
